import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../utils/enums';
import { useAPI } from '@pella/cosmos-react';
import { useSites } from '../useSites/useSites';

/**
 * Fetches team member data from the TeamMembersAPI by badge number.
 * @param {string | number | undefined} badgeNumber
 */
export const useTeamMemberByBadgeNumber = (badgeNumber) => {
  const { api, apiReady } = useAPI();
  const { data: sites } = useSites();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.TEAM_MEMBER_DATA, badgeNumber],
    queryFn: async () => {
      const result = await api.teamMember.getTeamMemberByBadgeNumber(String(badgeNumber));
      if (!result) throw new Error('Team Member not found');
      return result;
    },
    enabled: Boolean(apiReady) && Boolean(badgeNumber),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Add site data to team member when data is available
  const matchedSite = Array.isArray(sites) ? sites.find((item) => item.OIMSiteID === data?.location_code) : undefined;
  const teamMember = data
    ? {
        ...data,
        ...(matchedSite !== undefined ? { site: matchedSite } : {}),
      }
    : data;

  return { data: teamMember, isLoading, isError, error };
};
